import moment from "moment";
import { useState } from "react";
import CustomDatePicker from "../../CustomDatePicker/CustomDatePicker";
import { Button } from "devextreme-react/button";
import styles from "./AppointmentDateCard.module.css";
const AppointmentDateCard = ({
  setFromDate,
  setToDate,
  fromDate,
  toDate,
  fetchingAvailableSlots,
  infoText,
  setInfoText,
  setDateRangeList
}) => {
  return (
    <div className={styles.appointmentDateCard}>
      <div className={styles.appointmentDateCard__appointmentDate}>
        <CustomDatePicker
          title="from"
          date={fromDate}
          width="45%"
          onChange={(e) => {
            if ( moment(e).format("YYYY-MM-DD") >moment(toDate).format("YYYY-MM-DD")){
             let  nextday = new Date(e).setDate(new Date(e).getDate()+1)
              console.log("*****nextday*****",nextday)
              setToDate(nextday);

            }
            setInfoText(null);
            setFromDate(e);
            setDateRangeList([])
          }}
          margin="5px"
        />
        <CustomDatePicker
          title="to"
          date={toDate}
          width="45%"
          onChange={(e) => {
            if ( moment(fromDate).format("YYYY-MM-DD") >moment(e).format("YYYY-MM-DD")){
             let  previousDay = new Date(e).setDate(new Date(e).getDate()-1)
              console.log("*****previousDay*****",previousDay)
              setFromDate(previousDay);

            }
           
            setInfoText(null);
            setToDate(e);
            setDateRangeList([])
          }}
          margin="5px"
        />
      </div>
      <div style={{ marginTop: "10px",display:"flex", justifyContent:"center" }}>
        <Button
          text="Fetch Available slots"
          height={"32px"}
          type="default"
          onClick={fetchingAvailableSlots}
        />
      </div>
      {infoText && <div className={styles.info_text}>{infoText} </div>}
    </div>
  );
};

export default AppointmentDateCard;
